import { NgModule } from '@angular/core';

import {  RequiresPermissionCanViewDirective } from './hasPermission.directive';
import { PermissionsDeniedComponent } from './permissionsdenied.component';
import { MaterialModule } from '../material.module';
import { FuseAlertModule } from '@fuse/components/alert';

@NgModule({
  imports: [MaterialModule, FuseAlertModule],
  exports: [RequiresPermissionCanViewDirective, PermissionsDeniedComponent],
  declarations: [RequiresPermissionCanViewDirective, PermissionsDeniedComponent],
  providers: [],
})
export class PermissionsModule { }
